import { useTranslate } from "hooks/useTranslate";
import { tokens } from "styles/Tokens";
import Button from "../Button";
import DialogFormation from "../DialogFormation";
import Typography from "../Typography";
import "./index.scss";

interface props {
  openCounter?: boolean;
  onClose: () => void;
  countdown: number;
  open: boolean;
}

const LogoutCountdown = (props: props) => {
  const { onClose, countdown, open } = props;
  const translate = useTranslate();

  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <>
      {open && (
        <DialogFormation
          openDialog={open}
          handleClose={onClose}
          title={translate("logout.logoutHeader")}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="contained" label="Extend Session" className="extend-button" onClick={onClose} />
            </div>
          }
          closeButtonClass="logout-close"
        >
          <div className="logout-counter-component">
            <div className="logout-counter-container">
              {" "}
              <Typography variant={"h3"} color={tokens.Text.General.Color}>
                {formatTime(countdown)}
              </Typography>
              <div>
                <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} textAlign={"center"}>
                  {translate("logout.logoutMessage1")}
                </Typography>
                <Typography variant={"body2"} color={tokens.Text.General.PrimaryBody} textAlign={"center"}>
                  {translate("logout.logoutMessage2")}
                </Typography>
              </div>
            </div>
          </div>
        </DialogFormation>
      )}
    </>
  );
};

export default LogoutCountdown;
